var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import Theme from '../Theme';
import { toNumber, toRound, toMoney, toPercentage, toDate, toTime, toDateTime } from 'helpers/Format';
var Text = /** @class */ (function (_super) {
    __extends(Text, _super);
    function Text() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Text.prototype.format = function (text) {
        var _a = this.props, _number = _a.number, round = _a.round, money = _a.money, percentage = _a.percentage, date = _a.date, time = _a.time, dateTime = _a.dateTime;
        if (_number)
            return toNumber(text);
        if (round)
            return toRound(text);
        if (money)
            return toMoney(text, typeof money === 'string' ? money : null);
        if (percentage)
            return toPercentage(text);
        if (date)
            return toDate(text);
        if (time)
            return toTime(text);
        if (dateTime)
            return toDateTime(text);
        return text;
    };
    Text.prototype.render = function () {
        var _a = this.props, children = _a.children, style = _a.style, big = _a.big, small = _a.small, lines = _a.lines, center = _a.center, right = _a.right, primary = _a.primary, color = _a.color, verticalCenter = _a.verticalCenter, props = __rest(_a, ["children", "style", "big", "small", "lines", "center", "right", "primary", "color", "verticalCenter"]);
        var text = this.format(children);
        var verticalCenterStyle;
        if (verticalCenter) {
            verticalCenterStyle = {
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
            };
        }
        return (React.createElement("p", __assign({}, props, { 
            /*numberOfLines={lines}*/
            style: __assign(__assign({ fontFamily: Theme.fontFamily, fontSize: (big && Theme.fontSize.big) ||
                    (small && Theme.fontSize.small) ||
                    Theme.fontSize.regular, 
                /*lineHeight:
                  (big && Theme.line.big) ||
                  (small && Theme.line.small) ||
                  Theme.line.regular,*/
                color: primary ? Theme.color.primary : color ? color : Theme.color.secondary, textAlign: center ? 'center' : right ? 'right' : undefined }, style), verticalCenterStyle) }), text));
    };
    return Text;
}(Component));
export default Text;



//////////////////
// WEBPACK FOOTER
// ./src/elements/Text.tsx
// module id = 48
// module chunks = 0